import {AccountSummary} from '../../../shared/model/account/accountSummary.model';
import {EntityWithAuditMetadata} from './entityWithAuditMetadata';

export abstract class EntityLinkedToAccountWithAuditMetadata extends EntityWithAuditMetadata{
    account: AccountSummary;
}
